var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb--wrap"},[_c('VLayout',{staticClass:"breadcrumbs",attrs:{"justify-center":""}},_vm._l((_vm.breadcrumbs),function(crumb,i){return _c('RouterLink',{key:`${crumb.link || 'no-link'}-${i}`,staticClass:"breadcrumb flex shrink",attrs:{"to":crumb.link || ''}},[_vm._v(_vm._s(crumb.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }